import { useQuery } from '@tanstack/react-query';
import type { ActivityOverviewStatusFilter } from '@sparkapp/shared-types';
import { activityOverviewApi } from '../services/activityOverviewApi';
import { queryKeys } from '../utils/queryKeys';

export function useActivityOverview(status: ActivityOverviewStatusFilter) {
  return useQuery({
    queryKey: queryKeys.activities.overview(status),
    queryFn: () => activityOverviewApi.getOverview(status),
    staleTime: 60 * 1000,
  });
}
